
// region JS Imports

// region External Modules
import $ from "jquery"
// endregion External Modules

// Private Modules
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"

import {
  onSignedIn,
} from "app/authentication/remote_state"
// Private Modules

// region Public Components
import BS3_Dropdown from "components/bootstrap3-like-dropdown"
// endregion Public Components

// region Private Components
import {
  Factory as CitySelectMenuFactory,
} from "./components/city_select_menu/index"

import {
  Factory as AreaSizeSelectMenuFactory,
} from "./components/area_size_select_menu/index"

import {
  Factory as LanguageSelectFactory,
  LanguageSelect,
} from "./components/language_select/index"
// endregion Private Components

// endregion JS Imports


const getMainNavbar = () => {
  return $(".main-navbar-desktop")
}

function initAllMatchingElements() {
  BS3_Dropdown.init({
    scope:              ".main-navbar-desktop",
    dropdown_toggle:    ".dropdown-toggle",
    dropdown_container: ".dropdown",
  })
}

const init = () => {
  if (getMainNavbar().length !== 1) { return }

  CitySelectMenuFactory.instance()
  AreaSizeSelectMenuFactory.instance()
  LanguageSelectFactory.instance()

  WaitObjectByPathPromise("window._spacious_main_css_loaded")
    .then(() => {

      initAllMatchingElements()

      $(document).on("ajaxSuccess", () => {
        // to wait for dom tree update before update
        // TODO: do these reinitialization on some events only instead globally
        setTimeout(initAllMatchingElements, 200)
      })

      onSignedIn(() => {
        initAllMatchingElements()
      })
    })
    .done()
}


export default {
  init,
  // initAllMatchingElements,
}
